import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { StringAnyMap } from 'src/app/core/models/common.models';
import { WorkflowStatusesStoreService } from 'src/app/core/store/services/workflow-statuses-store.service';
import { BaseSingleSelectComponent } from '../craft-single-select/craft-single-select.component';

@Component({
  selector: 'craft-workflow-statuses-select',
  templateUrl: './craft-workflow-statuses-select.component.html',
  styleUrls: ['./craft-workflow-statuses-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CraftWorkflowStatusesSelectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CraftWorkflowStatusesSelectComponent extends BaseSingleSelectComponent implements OnInit, OnChanges {
  @Input() public items: Readonly<StringAnyMap>;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    private workflowStatusesStore: WorkflowStatusesStoreService,
  ) {
    super(changeDetectorRef);
    this.idFieldName = 'id';
    this.labelFieldName = 'name';
  }

  public ngOnInit() {
    super.ngOnInit();
    this.workflowStatusesStore.map$.pipe(takeUntil(this.destroy$)).subscribe((statuses) => {
      this.setItems(statuses, this.selectedId);
    });
  }
}
